import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { useAuth } from "../../context/AuthContext";
import { PageErrorBoundary } from "../PageErrorBoundary";
import { ProductFooter } from "../ProductFooter";
import { LoginForm } from "../auth/LoginForm";
import { TwoFactorGate } from "../auth/TwoFactorGate";

export function AppLayout() {
  const { isAuthenticated, isLoading, refreshSession } = useAuth();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"></div>
      </div>
    );
  }

  // Show login form when not authenticated. This used to be YouWare's
  // hosted `client.auth.renderAuthUI(...)` widget — replaced with a real
  // component now that there's no hosted platform to render it for us.
  if (!isAuthenticated) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <LoginForm onLogin={refreshSession} />
      </div>
    );
  }

  return (
    <TwoFactorGate>
      <div className="flex h-screen overflow-hidden bg-gray-100">
        <Sidebar />
        <div className="flex flex-1 flex-col overflow-hidden">
          <Header />
          <main className="flex-1 overflow-auto p-6">
            <PageErrorBoundary>
              <Outlet />
            </PageErrorBoundary>
          </main>
          <ProductFooter />
        </div>
      </div>
    </TwoFactorGate>
  );
}
